import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getAllCitiesList = async (): Promise<IGetCitiesList []> => {
  return axiosDefaultApi.get(`api/Cities/GetCities`);
};

type QueryFnType = typeof getAllCitiesList;

type UseGetAllCitiesListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllCitiesList = ({ config }: UseGetAllCitiesListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllCitiesList'],
    queryFn: () => getAllCitiesList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των Πόλεων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};